module.exports = __webpack_public_path__ + "img/BINDI 2 PURPLE.25101d5.svg";